import { render } from "./CarouselTestimonios.vue?vue&type=template&id=15f83cda"
import script from "./CarouselTestimonios.vue?vue&type=script&lang=js"
export * from "./CarouselTestimonios.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__